import React, {FC, useCallback, useEffect, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../_metronic/helpers'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {
  useGetAllSegmentsQuery,
  useGetAllTagsQuery,
  useGetContactsByGroupMutateMutation,
  useGetSegmentContactWithPaginateMutateMutation,
} from '../../services/cellcast'
import Select from 'react-select'
import {toast} from 'react-toastify'
import SelectFloatingButton from './SelectFloatingButton'
import {ContactGroupMap} from '../../services/cellcast.v2.types'

type SelectTagOrSegmentOption = {
  value: string
  label: string
  group: string
}

const QMConctactSegmentListPopup: FC<any> = ({show, handleClose, selectedCallback}) => {
  const groupid: any = useSelector((state: any) => state?.subscriberData?.FieldName?.data?._id)
  const groupField = useSelector((state: any) => state?.subscriberData?.FieldName?.data?.fields)

  // local state
  const [selectedOption, setSelectedOption] = useState<SelectTagOrSegmentOption[]>([])
  const [segmentTagOptions, setSegmentTagOptions] = useState<any[]>([])
  const [filter, setFilter] = useState({
    page: 1,
    size: 10,
    search: '',
  })
  const [selectedContacts, setSelectedContact] = useState<any>([])
  const [firstLoad, setFirstLoad] = useState(false)
  const [contactData, setContactData] = useState<any>()

  // fetch function
  const {isLoading: loadingTags, data: tags} = useGetAllTagsQuery({})
  const {isLoading: loadingSegment, data: segments} = useGetAllSegmentsQuery({})
  const [fetchContact, {isLoading: loadingContact, data: contacts}] =
    useGetSegmentContactWithPaginateMutateMutation()
  const [fetchContactByGroup, {isLoading: loadingContactByGroup, data: contactsByGroup}] =
    useGetContactsByGroupMutateMutation()

  // hook effect
  useEffect(() => {
    let options = []

    if (!segments && !tags) {
      setSegmentTagOptions([])
      return
    }

    if (segments && segments.data && Array.isArray(segments.data)) {
      const segmentOptions = segments.data.map((el: any) => {
        return {
          value: el._id,
          label: el.name,
          group: 'segment',
        }
      })
      // options.push(segmentOptions)
      options.push({
        label: 'Segment',
        options: segmentOptions,
      })
    }

    // if (tags && tags.data && Array.isArray(tags.data)) {
    //   const tagOptions = tags.data.map((el: any) => {
    //     return {
    //       value: el._id,
    //       label: el.name,
    //       group: 'tag',
    //     }
    //   })
    //   options.push({
    //     label: 'Tag',
    //     options: tagOptions,
    //   })
    // }
    setSegmentTagOptions(options)
  }, [loadingSegment, segments])

  useEffect(() => {
    if (
      selectedOption.length === 0 ||
      (selectedOption.length > 0 && selectedOption[0].value === '')
    ) {
      return
    }

    if (
      selectedOption.length > 0 &&
      selectedOption[0].value !== '' &&
      selectedOption[0].group === 'segment'
    ) {
      fetchContact({
        page: filter.page,
        size: filter.size,
        search: filter.search,
        segmentId: selectedOption[0].value,
      }).then((res) => {
        if ('data' in res) {
          if (firstLoad !== true) {
            setFirstLoad(true)
          }
          setContactData(res.data)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
    }

    if (
      selectedOption.length > 0 &&
      selectedOption[0].value !== '' &&
      selectedOption[0].group === 'tag'
    ) {
      let tagIDs = selectedOption.flatMap((el) => el.value).join(',')
      fetchContactByGroup({
        page: filter.page,
        size: filter.size,
        search: filter.search,
        tagId: tagIDs,
        groupId: groupid,
      }).then((res) => {
        if ('data' in res) {
          if (firstLoad !== true) {
            setFirstLoad(true)
          }
          setContactData(res.data)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
    }
  }, [selectedOption, filter])

  const handleCheckAll = () => {
    if (selectedContacts?.length === contactData?.data?.items?.length) {
      setSelectedContact([])
    } else {
      const list = contactData?.data?.items?.map((key: any) => key._id)
      if (Array.isArray(list)) {
        setSelectedContact([...list])
      }
    }
  }

  const handleCheck = (e: any) => {
    if (selectedContacts && selectedContacts.includes(e._id)) {
      selectedContacts.splice(selectedContacts?.indexOf(e._id), 1)
      setSelectedContact([...selectedContacts])
    } else {
      setSelectedContact([...selectedContacts, e._id])
    }
  }

  const handleSelectCallback = () => {
    if (selectedContacts.length > 0 && selectedCallback) {
      const foundContacts = contactData?.data?.items?.filter((el: any) =>
        selectedContacts.includes(el._id)
      )
      if (foundContacts && foundContacts.length > 0) {
        const foundContactNumbers = foundContacts.map((el: any) => el.number)
        selectedCallback(foundContactNumbers)
        setSelectedContact([])
      }
    }
  }

  const handleSelectOptions = (selectValues: SelectTagOrSegmentOption[]) => {
    let segmentValues = selectValues.filter((el) => el.group === 'segment')
    let tagValues = selectValues.filter((el) => el.group === 'tag')

    if (segmentValues.length > 0) {
      if (segmentValues.length > 1) {
        setSelectedOption([segmentValues[segmentValues.length - 1]])
      } else {
        setSelectedOption(segmentValues)
      }
    } else if (tagValues.length > 0) {
      setSelectedOption(tagValues)
    } else {
      setSelectedOption([])
    }
  }

  const getTagsByIDs = (tagIds: string[]) => {
    if (!tagIds) {
      return []
    }

    if (Array.isArray(tagIds) && tagIds.length === 0) {
      return []
    }

    if (typeof tagIds[0] !== 'string') {
      return tagIds
    }

    let tmpTags: any[] = []
    tagIds.forEach((el) => {
      if (tags && tags.data && Array.isArray(tags.data)) {
        const foundTag = tags.data.find((f: any) => f._id === el)
        if (foundTag) {
          tmpTags.push(foundTag)
        }
      }
    })
    return tmpTags
  }

  // helper
  const getMaxTagsSize = (contacts: ContactGroupMap[]): number => {
    let tagsCharLength = 0
    getTagsByIDs(contacts?.map((it) => it?.tags) as any).forEach((el) => {
      if (el.length > 0) {
        let tagCharSize = 0
        el.forEach((el: any) => {
          tagCharSize += el?.length
        })

        tagsCharLength += tagCharSize
      }
    })

    return tagsCharLength
  }

  const checkField = useCallback(() => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (groupField?.find((val: any) => fields.includes(val)) === undefined) {
      return false
    } else {
      return true
    }
  }, [groupField])

  return (
    <>
      <Modal
        tabIndex={1}
        aria-hidden='true'
        aria-labelledby='contained-modal-title-vcenter'
        show={show}
        size='lg'
        scrollable={false}
        className='fade w-80'
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Contacts List</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div
          className='modal-body'
          style={{
            paddingTop: 0,
            paddingBottom: 0,
          }}
        >
          <div className='card'>
            <div className='card-header align-items-center border-bottom-0' style={{paddingTop: '0px !important', marginTop:0 }}>
              <div className='row w-100'>
                <div className='col-md-8 mb-5'>
                  <Select
                    value={selectedOption}
                    isClearable={true}
                    isDisabled={loadingSegment}
                    onChange={(e: any) => handleSelectOptions(e)}
                    options={segmentTagOptions}
                    isMulti
                  />
                </div>
                <div className='col-md-4'>
                  {selectedContacts.length > 0 && (
                    <button
                      className='btn msg-primary-btn send btn-primary'
                      onClick={() => handleSelectCallback()}
                    >
                      {`select ${selectedContacts?.length} data`}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className='card-body'>
            <div
              style={{
                maxHeight: 400,
                maxWidth: '100%',
                overflow: 'scroll',
                minHeight:
                  contactData?.data?.items < 10 || loadingContact || loadingContactByGroup
                    ? 450
                    : 300,
              }}
            >
              {!firstLoad && (loadingContact || loadingContactByGroup) && (
                <div className='row flex-center h-200'>Fetching data ...</div>
              )}
              {loadingContact ? (
                <div className='row flex-center h-200' style={{minHeight: 200}}>
                  <Spinner animation='grow' />
                </div>
              ) : (
                <div className='table-responsive'>
                  <>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold text-muted text-uppercase'>
                          <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='ALL'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                                checked={
                                  selectedContacts?.length >= contactData?.data?.items?.length
                                }
                                onChange={handleCheckAll}
                              />
                            </div>
                          </th>
                          <th>Mobile</th>
                          <th
                            style={{
                              minWidth: getMaxTagsSize(contactData?.data?.items) > 10 ? 250 : 0,
                            }}
                          >
                            Tags
                          </th>

                          <th>Status</th>
                          <th>Email</th>
                          {checkField() && groupField.includes('First Name') && <th>First Name</th>}
                          {checkField() && groupField.includes('Last Name') && <th>Last Name</th>}
                          {checkField() && groupField.includes('Full Name') && <th>Full Name</th>}
                          {groupField?.map((val: any, i: any) => {
                            if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                              return <th key={i}>{val}</th>
                            }
                          })}
                        </tr>
                      </thead>
                      <tbody className='text-gray-600'>
                        {loadingContact || loadingContactByGroup ? (
                          <tr>
                            <td colSpan={6} className='text-center'>
                              Fetching data ...
                            </td>
                          </tr>
                        ) : (
                          <>
                            {contactData?.data?.items?.map((val: any, i: number) => (
                              <tr key={i}>
                                <td>
                                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                    <input
                                      className='form-check-input widget-9-check'
                                      type='checkbox'
                                      value={val?._id}
                                      checked={selectedContacts?.includes(val?._id)}
                                      onChange={() => handleCheck(val)}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <b>{val?.number}</b>
                                </td>
                                <td
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='top'
                                  title={getTagsByIDs(val?.tags)
                                    .filter((key: any) => key?.isHidden === false)
                                    ?.map((key: any) => key?.name)
                                    .join()}
                                >
                                  <div className='d-flex gap-2 align-items-center flex-wrap'>
                                    {getTagsByIDs(val?.tags)
                                      .filter((data: any) => !data?.isHidden)
                                      ?.map((data: {name: string; color: string}, i: number) => (
                                        <div
                                          key={i}
                                          className='inbox-tags'
                                          style={{
                                            color: data?.color ? 'white' : 'black',
                                            backgroundColor: data?.color ? data?.color : '',
                                          }}
                                        >
                                          {data?.name}
                                        </div>
                                      ))}
                                  </div>
                                </td>
                                <td>
                                  {val?.contact?.isBlockedByUser || val?.contact?.isBlocked
                                    ? 'Unsubscribed'
                                    : 'Subscribed'}
                                </td>
                                {val?.fields?.findIndex(
                                  (val: any) => val?.name === 'First Name'
                                ) !== -1 ? (
                                  <td>
                                    {
                                      val?.fields?.[
                                        val?.fields?.findIndex(
                                          (val: any) => val?.name === 'First Name'
                                        )
                                      ]?.value
                                    }
                                  </td>
                                ) : (
                                  <td className='text-center'>-</td>
                                )}
                                {val?.fields?.findIndex((val: any) => val?.name === 'Last Name') !==
                                -1 ? (
                                  <td>
                                    {
                                      val?.fields?.[
                                        val?.fields?.findIndex(
                                          (val: any) => val?.name === 'Last Name'
                                        )
                                      ]?.value
                                    }
                                  </td>
                                ) : (
                                  <td className='text-center'>-</td>
                                )}
                                {groupField.map((Fields: any, i: number) => {
                                  let check = val?.fields?.map((key: any) => key?.name)
                                  if (!['First Name', 'Full Name', 'Last Name']?.includes(Fields)) {
                                    if (check?.includes(Fields)) {
                                      return (
                                        <td key={i}>
                                          {
                                            val?.fields?.find((key: any) => key?.name == Fields)
                                              ?.value
                                          }
                                        </td>
                                      )
                                    } else {
                                      return <td key={i}>--</td>
                                    }
                                  }
                                })}
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='modal-footer w-100 mt-0 pt-0'>
          <div className='abcd '>
            <select onChange={(e: any) => setFilter({...filter, size: e.target.value, page: 1})}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
            </select>
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={contactData?.data?.totalPages}
              onPageChange={(e: any) => setFilter({...filter, page: e.selected + 1})}
              containerClassName={'pagination'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default QMConctactSegmentListPopup
